<div class="row">
  <div class="col-md-12 text-center">
    <h1 class="title">Select Active Role</h1>
  </div>
</div>
<div class="row">
  <div class="col-md-4 offset-md-4">
    <div class="card">
      <div class="card-body">
        <div class="col-md-12">
          <mat-radio-group name="roleSelectList" *ngIf="loadedRoles" aria-label="Select a role" [(ngModel)]="currentRoleIDSelection">
            <div class="row" *ngFor="let role of availableRoles">
              <mat-radio-button name="roleSelectList" [value]="role.value" (change)="onRoleChange()">
                {{role.title}}
              </mat-radio-button>
            </div>
          </mat-radio-group>
        </div>
      </div>
    </div>
  </div>
</div>



<div *ngIf="showProjects" class="row">
  <!--  currentRoleSelection != null && currentRoleSelection.roletypeid != roletypeenum.admin -->
  <div class="col-md-12 text-center">
    <h1 class="title">Select Active Project</h1>
  </div>
</div>
<div *ngIf="showProjects" class="row">
  <div class="col-md-6 offset-md-3">
    <div class="card">
      <div class="card-body">
        <div class="col-md-12">
          <div *ngIf="hasProjects" class="col-md-12">
            <mat-radio-group name="projectSelectList" aria-label="Select a project" [(ngModel)]="currentProjectSelection">
              <div class="row" *ngFor="let project of availableProjects; let i = index">
                <mat-radio-button name="projectSelectList" [value]="project.value" (change)="onProjectChange()">
                  {{project.title}}
                </mat-radio-button>
              </div>
            </mat-radio-group>
          </div>
          <div *ngIf="!hasProjects" class="col-md-12 text-center">
            No projects currently available
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="showTeams" class="row">
  <!-- ngif (currentProjectSelection != null && currentRoleSelection.roletypeid == roletypeenum.coder)  -->
  <div class="col-md-12 text-center">
    <h1 class="title" style="color:black">Select Active Team</h1>
  </div>
</div>
<div *ngIf="showTeams" class="row">
  <div class="col-md-6 offset-md-3">
    <div class="card">
      <div class="card-body">
        <div class="col-md-12">
          <div *ngIf="hasTeams" class="col-md-12">
            <mat-radio-group name="teamSelectList" aria-label="Select a team" [(ngModel)]="currentTeamSelection">
              <div *ngFor="let team of availableTeams">
                <mat-radio-button name="teamSelectList" [value]="team.value" (change)="onTeamChange()">
                  {{team.title}}
                </mat-radio-button>
              </div>
            </mat-radio-group>
          </div>
          <div *ngIf="!hasTeams" class="col-md-12 text-center">
            No teams currently available
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<br />
<!-- ngif (currentRoleSelection != null && currentRoleSelection.roletypeid == roletypeenum.admin) || (currentProjectSelection != null && currentRoleSelection.roletypeid == roletypeenum.supervisor)  || (currentTeamSelection != null) -->
<div *ngIf="showSubmit" class="row">
  <div class="col-md-4 offset-md-6">
    <button type="button" class="btn btn-primary" (click)="submitTeamAndRoleSelection()" [disabled]="authService.updatingTokenInProgress">Submit</button>
  </div>
</div>
